import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { UseAuthContext } from '../../../context/AuthContext';
import { resizeFile } from '../../../assets/js/imageReSizer';
import { addUser,addTeacher,addMess,deleteTeacher, deleteMess } from '../../../firebase';
import { defaultImage } from '../../../context/defaultImg';
import EditTeacherProfile from './EditTeacherProfile';
import EditMessProfile from './EditMessProfile';
import {detail} from '../../../context/store';

export default function EditUser() {
    const { user, setUser, teacher, setTeacher, mess, setMess } = UseAuthContext();
    const [editInfo, setEditInfo] = useState(user);
    const [editTeacher, setEditTeacher] = useState(teacher);
    const [editMess, setEditMess] = useState(mess.details);
    const [loading, setLoading] = useState(false);
    const profilePicRef = useRef();

    useEffect(() => {
        setEditInfo(user);
        setEditTeacher({...teacher,id:user.id});
        setEditMess(mess.details);
    }, [user, teacher, mess]);

    const handleUser = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (e.target.type === 'file' && e.target.files[0]) {
            resizeFile(e.target.files[0]).then(res => setEditInfo(previous => ({ ...previous, [name]: res })))
        } else {
            setEditInfo(previous => ({ ...previous, [name]: value }));
        }
    }

    const handleTeacher = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setEditTeacher(pre => ({ ...pre, [name]: value }))
    }

   const addNewMess = () =>{
       let id=Date.now().toString();
        setEditMess(pre=>([{...detail,id:id},...pre]))
   }

    const submitHandle = (e) => {
        setLoading(true);
        e.preventDefault();
        addUser(editInfo).then(()=>{
            setUser(editInfo);
            setLoading(false);
            if(editInfo.profile.includes('Teacher')){
                addTeacher({
                    ...editTeacher,
                    id:editInfo.id,
                    name:editInfo.name,
                    pic:editInfo.pic,
                    gender:editInfo.gender
                }).then(()=>{
                   setTeacher({
                    ...editTeacher,
                    id: editInfo.id,
                    name:editInfo.name,
                    pic:editInfo.pic,
                    gender:editInfo.gender
                })
            })
            }else if(teacher.id){
                deleteTeacher(teacher.id);
            }
            if(editInfo.profile.includes('Mess')){
                addMess({
                    id:editInfo.id,
                    details:editMess
                }).then(()=>{
                    setMess({
                        id:editInfo.id,
                        details:editMess
                    })
                })
            }else if(mess.id){
                deleteMess(mess.id);
            }
            
        })
    }

    const uploadImage = () => {
        document.getElementById("my_file").click();
    }
    const resetImage = () => {
        profilePicRef.current.value = "";
        setEditInfo(pre => ({ ...pre, pic: defaultImage }))
    }


    const handleUserCheckbox = (e) => {
        let check = e.target.checked;
        let value = e.target.value;
        if (check) {
            setEditInfo(pre => ({ ...pre, profile: [...pre.profile, value] }));
        } else {
            setEditInfo(pre => ({ ...pre, profile: pre.profile.filter(data => data !== value) }));
        }
    }

    return (
        <main id="main">
            <section id="portfolio-details" className="portfolio-details text-start">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-4">
                            <div className="portfolio-details-slider">
                                <div className="text-center">
                                    <img src={editInfo.pic} alt="add" />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 col-sm-12">
                                    <input type="file" id="my_file" name="pic" style={{ display: "none" }} ref={profilePicRef} onChange={handleUser} />
                                    <div className="d-grid gap-2 col-6 mx-auto">
                                        <button className="btn btn-secondary" type="button" onClick={() => uploadImage()}><i className='bx bxs-camera'></i> Upload</button>
                                        {defaultImage !== editInfo.pic && <button className="btn btn-light" onClick={() => resetImage()} type="button"><i className='bx bxs-camera-off'></i> Cancel</button>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-5 col-sm-5">
                                            <span>Edit Profile</span>
                                        </div>
                                        <div className="col-7 col-sm-7 text-end">
                                            <button className="btn btn-secondary btn-sm mx-2" onClick={submitHandle}
                                            disabled={loading}>{loading?"Wait":"Save"}</button>
                                            <Link to="/account"><button className="btn btn-danger btn-sm" >cancel</button></Link>
                                        </div>
                                    </div>
                                </h3>
                                <div className="php-email-form">
                                    <div className="row gy-3">
                                        <div className="col-6 col-sm-6">
                                            <input type="text" name="name" className="form-control" placeholder="Name" value={editInfo.name} onChange={handleUser} />
                                        </div>
                                        <div className="col-6 col-sm-6">
                                            <input type="email" name="email" className="form-control" placeholder="Email" value={editInfo.email} onChange={handleUser} />
                                        </div>
                                        <div className="col-6 col-sm-6">
                                            <select className="form-select" name="gender" value={editInfo.gender} onChange={handleUser}>
                                                <option value="None">Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                        <div className="col-6 col-sm-6">
                                            <input type="text" className="form-control" value={editInfo.phone} name="phone" placeholder="Mobile Number" disabled />
                                        </div>
                                        <div className="col-12 col-sm-12">
                                            <div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="checkbox" id="Teacher" value="Teacher"
                                                        checked={editInfo.profile.includes("Teacher")} onChange={handleUserCheckbox} />
                                                    <label className="form-check-label" htmlFor="Teacher">Teacher</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="checkbox" id="Mess" value="Mess"
                                                        checked={editInfo.profile.includes("Mess")} onChange={handleUserCheckbox} />
                                                    <label className="form-check-label" htmlFor="Mess">Mess/Flat</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {editInfo.profile.includes("Teacher") && <div className="col-lg-12">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-5 col-sm-5">
                                            <span>Teacher</span>
                                        </div>
                                    </div>
                                </h3>
                                <div className="php-email-form">
                                    <EditTeacherProfile handleTeacher={handleTeacher} editTeacher={editTeacher} />
                                </div>
                            </div>
                        </div>}

                        {editInfo.profile.includes("Mess") && <div className="col-lg-12">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-5 col-sm-5">
                                            <span>Mess/Flat</span>
                                        </div>
                                        <div className="col-7 col-sm-7 text-end">
                                            <button className="btn btn-secondary" 
                                            onClick={()=>addNewMess()}>Add New</button>
                                        </div>
                                    </div>
                                </h3>
                                <div className="php-email-form">
                                    {editMess.map((m, index) => <EditMessProfile key={index}
                                        editMessDetails={m} setEditMess={setEditMess} />)}
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </section>
        </main>
    );
}